import { PartnerUser, PartnerUsersOrder } from "@/models/partnerUsers";
import { AxiosResponse } from "axios";
import qs from "qs";
import { httpClient } from "./API";

export const getPartnerUsersAPI = async (
  page: number,
  size: number,
  order: PartnerUsersOrder,
  officeIds?: number[],
  name?: string
): Promise<AxiosResponse<PartnerUser[]>> => {
  const sort = Object.entries(order)
    .filter(([, v]) => v!!)
    .map(([k, v]) => `${k},${v}`);

  return httpClient.get("core/internal/calgary/partnerUsers/", {
    params: { name, officeIds, size, sort, page: page - (page < 1 ? 0 : 1) },
    paramsSerializer: (params) =>
      qs.stringify(params, { arrayFormat: "repeat", encode: false }),
  });
};

export const getPartnerUsersCountAPI = async (
  officeIds?: number[],
  name?: string
): Promise<AxiosResponse<number>> => {
  return httpClient.get("core/internal/calgary/partnerUsers/count/", {
    params: { officeIds, name },
    paramsSerializer: (params) =>
      qs.stringify(params, { arrayFormat: "repeat", encode: false }),
  });
};

export const getPartnerUserAPI = async (
  id: number
): Promise<AxiosResponse<PartnerUser>> => {
  return httpClient.get(`core/internal/calgary/partnerUsers/${id}`);
};

export const updatePartnerUserAPI = async (
  id: number,
  request: PartnerUser
): Promise<AxiosResponse<PartnerUser>> => {
  return httpClient.put(`core/internal/calgary/partnerUsers/${id}`, request);
};
